import React, { useEffect, useState } from "react";
import { Field } from "formik";
import { makeStyles } from 'tss-react/mui';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import SupportAgentOutlined from "@mui/icons-material/SupportAgentOutlined";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles()(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

const QueueSelectSingle = ({ hideLabel = false }) => {
    const { classes } = useStyles();
    const [queues, setQueues] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/queue");
                setQueues(data);
            } catch (err) {
                toastError(`QUEUESELETSINGLE >>> ${err}`);
            }
        })();
    }, []);

    return (
        <div style={{ marginTop: hideLabel ? 0 : 6 }}>
            <FormControl
                variant="outlined"
                className={classes.FormControl}
                size="small"
                margin={hideLabel ? "none" : "dense"}
                fullWidth
            >
                <div>
                    {!hideLabel && (
                        <Typography>
                            {i18n.t("promptModal.form.handoffQueue")}
                        </Typography>
                    )}
                    <Field
                        as={Select}
                        label={i18n.t("promptModal.form.handoffQueue")}
                        name="queueId"
                        labelId="queue-selection-label"
                        id="queue-selection"
                        size="small"
                        fullWidth
                        startAdornment={
                            <InputAdornment position="start">
                                <SupportAgentOutlined fontSize="small" color="disabled" />
                            </InputAdornment>
                        }
                    >
                        {queues.map(queue => (
                            <MenuItem key={queue.id} value={queue.id}>
                                {queue.name}
                            </MenuItem>
                        ))}
                    </Field>
                </div>
            </FormControl>
        </div>
    );
};

export default QueueSelectSingle;
